module.exports = __webpack_public_path__ + "3d600a7be790dc513d2e5ffda9e4f494.png";